import styled from "styled-components/macro";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

export const Header = styled.div`
	padding: 24px;
	margin-bottom: 24px;
	border-bottom: 1px solid #efefef;
`;

// export const Title = styled.div`
// 	color: #262626;
// 	font-family: "Inter";
// 	font-size: 24px;
// 	font-style: normal;
// 	font-weight: 600;
// 	line-height: normal;
// `;

export const Body = styled.div`
	width: 100%;
	height: calc(100vh - 450px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Wrapper = styled.div`
	height: 100%;
	width: 960px;
`;

export const RecordsContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	.handle {
		top: 15px !important;
	}
`;
